<template>
  <div class="flex gap-x-3 items-center">
    <span
      aria-hidden="true"
      v-text="'Sort'"
    />
    <AisSortBy
      :items="sortByItems"
      class="grow min-w-[200px]"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { AisSortBy } from 'vue-instantsearch/vue3/es'

defineOptions({
  name: 'BaseSearchSort',
})

const props = defineProps<{
  indexName: string
}>()

const sortByItems = computed(() => [
  { value: props.indexName, label: 'Default' },
  { value: `${props.indexName}_post_date_desc`, label: 'Newest to Oldest' },
  { value: `${props.indexName}_post_date_asc`, label: 'Oldest to Newest' },
  { value: `${props.indexName}_relevance_desc`, label: 'Relevance - DESC' },
  { value: `${props.indexName}_relevance_asc`, label: 'Relevance - ASC' },
])
</script>
